import { useNavigate } from 'react-router-dom';
import { Lock, Zap } from 'lucide-react';
import { useSubscription } from '../../contexts/SubscriptionContext';
import { useAuth } from '../../contexts/AuthContext';
import { useLocale } from '../../contexts/LocaleContext';

export default function SubscriptionGate({ children }) {
  const { t } = useLocale();
  const { isLocked, loading, accessStatus, subscription } = useSubscription();
  const { logout } = useAuth();
  const navigate = useNavigate();

  if (loading) return children;
  if (!isLocked) return children;

  const suspended = accessStatus === 'suspended';

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center p-4"
      style={{ backgroundColor: 'var(--bg-primary)' }}>

      <div className="absolute inset-0 overflow-hidden pointer-events-none">
        <div className="absolute top-0 -left-4 w-96 h-96 opacity-5 rounded-full blur-3xl"
          style={{ backgroundColor: 'var(--accent-danger)' }} />
        <div className="absolute bottom-0 -right-4 w-96 h-96 opacity-5 rounded-full blur-3xl"
          style={{ backgroundColor: 'var(--accent-primary)' }} />
      </div>

      <div className="relative z-10 max-w-md w-full text-center space-y-6">

        <div className="w-20 h-20 rounded-2xl mx-auto flex items-center justify-center"
          style={{ backgroundColor: 'var(--accent-danger)15', border: '2px solid var(--accent-danger)30' }}>
          <Lock className="w-10 h-10" style={{ color: 'var(--accent-danger)' }} />
        </div>

        <div>
          <h1 className="text-2xl font-black mb-2" style={{ color: 'var(--text-primary)' }}>
            {suspended ? t('subscriptionGate.accountSuspended') : t('subscriptionGate.subscriptionExpired')}
          </h1>
          <p className="text-sm leading-relaxed" style={{ color: 'var(--text-secondary)' }}>
            {suspended
              ? t('subscriptionGate.suspendedDesc')
              : t('subscriptionGate.expiredDesc').replace('{plan}', subscription?.plan_name || 'platform')
            }
          </p>
        </div>

        {!suspended && (
          <div className="space-y-3">
            <button onClick={() => navigate('/upgrade')}
              className="w-full flex items-center justify-center gap-2 py-3.5 rounded-xl text-base font-bold text-white transition-all"
              style={{ backgroundColor: 'var(--accent-primary)' }}>
              <Zap className="w-5 h-5" />
              {t('subscriptionGate.renewSubscription')}
            </button>
            <button onClick={logout}
              className="w-full py-2.5 rounded-xl text-sm font-medium transition-all"
              style={{ backgroundColor: 'var(--bg-secondary)', border: '1px solid var(--border-color)', color: 'var(--text-secondary)' }}>
              {t('subscriptionGate.signOut')}
            </button>
          </div>
        )}

        {suspended && (
          <button onClick={logout}
            className="w-full py-3 rounded-xl text-sm font-medium"
            style={{ backgroundColor: 'var(--bg-secondary)', border: '1px solid var(--border-color)', color: 'var(--text-secondary)' }}>
            {t('subscriptionGate.signOut')}
          </button>
        )}

        <p className="text-xs" style={{ color: 'var(--text-muted)' }}>
          {t('subscriptionGate.needHelp')}{' '}
          <a href="mailto:support@amortrade.com" className="underline" style={{ color: 'var(--accent-primary)' }}>
            support@amortrade.com
          </a>
        </p>
      </div>
    </div>
  );
}